import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';

import { saveAs as importedSaveAs } from 'file-saver';
import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { ReportableService } from '../../../services/reportable.service';
import { AssetRegisterService } from '../../../services/rs/assetregister.service';
import { Router } from '@angular/router';
import { FilterService } from '../../../services/filter.service';
import { Basket_Item } from '../../../models/Basket_Item';
import { BasketService } from '../../../services/rs/basket.service';

@Component({
  selector: 'app-assetregister',
  templateUrl: './assetregister.component.html',
  styleUrls: ['./assetregister.component.css']
})

export class AssetRegisterComponent implements OnInit {
  companies: Company[];
  locations: Location[];
  locationList: Location[];

  filter: any = {
    company_Id: undefined,
    location_Id: undefined,
    date_Range: 1,
    start_Date: moment().add(-1, 'months').toDate(),
    end_Date: moment().toDate(),
    serial_Num: '',
    status: -1
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));

  page = new Page();
  rows = Array<any>();

  is_client = false;
  client;
  init:boolean;
  
  constructor(public assetRegisterService: AssetRegisterService, public reportableService: ReportableService, public router: Router,
    private authService: AuthService, private companyService: CompanyService, private locationService: LocationService, private filterService: FilterService,
    public basketService: BasketService) {
    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;

    this.page.pageNumber = 0;
    this.page.size = 10;

/*    this.companyService.getAll().then((data) => {
      this.companies = data;

      if (this.is_client) {
        this.filter.company_Id = authService.currentUser.value.company_Id;
      }

      this.locationService.getAll().then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

        if (this.is_client) {
          this.locations = this.locationList.filter(c => {
            return c.company_Id == this.filter.company_Id;
          });
        }

        //Check if any filters are present
        var filters = filterService.getFilters(authService.currentUser.value.id, this.router.url);
        if (filters != null) {
          this.filter = filters;
        }

        this.loadTable(this.page);
      });
    });*/
  }

  onCompanyChange(value) {
    this.filter.location_Id = undefined;
    if (value == undefined) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  ngOnInit() {
    //this.loadTable(this.page);
    this.init = true;
  }

  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));

    if (this.is_client) {
      this.filter.company_Id = this.authService.currentUser.value.company_Id;

      this.onCompanyChange(this.filter.company_Id);
    } else {
      this.locations = this.locationList;
    }

    this.loadTable(this.page);
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    console.log("NEXT PAGE");
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);


  //  this.rows = rows;
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.filterService.saveFilters(this.authService.currentUser.value.id, this.router.url, this.filter);
    this.assetRegisterService.getResults(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.start_Date, this.filter.end_Date, this.filter.serial_Num, this.filter.status).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;

      this.refreshbasketrow();

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  downloadReport(id: number) {
    this.reportableService.getLiftingExam(id).then((data) => {
      importedSaveAs(data, 'Inspection Report.pdf');
    });
  }

  downloadAssetRegisterReport(id: String) {
    this.reportableService.getAssetRegister(id).then((data) => {
      importedSaveAs(data, 'Asset Register Report.pdf');
    });
  }

  addToBasket(item) {
    let basketItem = new Basket_Item();
    basketItem.id = item.inspection_Id;
    basketItem.description = item.serial_Num;
    basketItem.serial_Num = item.status;
    basketItem.category_Name = item.category_Name;
    basketItem.is_Annual = item.is_Annual;
    basketItem.category_Id = item.category_Id;
    basketItem.report_Type = 1;

    basketItem.safe = item.safe_For_Use;
    basketItem.type = "ROTE";

    this.basketService.add(basketItem);
    item.added = true;
  }
  removeFromBasket(item) {
    var basketItem = new Basket_Item();
    var items = this.basketService.getitems();

    for (let i = 0; i < (items.value.length); i++) {
      if ((items.value[i].description == item.serial_Num) && (items.value[i].serial_Num == item.status)) {
        this.basketService.remove(items.value[i]);
      }
    }
    item.added = false;
  }
  resetItem(item) {
    item.added = false;
  }

  resetItems() {
    for (let item of this.rows) {
      this.resetItem(item);
    }
  }

  basketCompleted(data) {
    this.resetItems();
  }

  basketClearing(data) {
    this.resetItems();
  }


  addAllToBasket() {
    this.assetRegisterService.getAll(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.start_Date, this.filter.end_Date, this.filter.serial_Num, this.filter.status).then((pagedData) => {
      for (let i = 0; i < pagedData.length; i++) {
        const jsonObj = pagedData[i];
        if (jsonObj.inspection_Id != null) {
           this.addToBasket(jsonObj);
        }
      }
      this.refreshbasketrow();
    });
  }

  dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
  }

  generateExcel() {
    this.assetRegisterService.getExcel(this.filter.company_Id, this.filter.location_Id, this.filter.start_Date, this.filter.end_Date, this.filter.serial_Num, this.filter.status).then((data) => {
      importedSaveAs(data, 'Report.xlsx');
    });
  }
  refreshbasketrow() {
    var items = this.basketService.getitems();
    for (let i = 0; i < (this.rows.length); i++) {
      let row = this.rows[i];
      for (let k = 0; k < (items.value.length); k++) {
        let item = items.value[k];
        if (item.id == row.inspection_Id) {
          this.rows[i].added = true;
        }
      }
    }
  }
  basketOnclickEvent(ev) {
    console.log(ev);
    console.log("CLICKED");
 //   this.refreshbasketrow();
    for (let i = 0; i < (this.rows.length); i++) {
      let row = this.rows[i];
        if (ev.id == row.inspection_Id) {
          this.rows[i].added = false;
      }
    }
  }
  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}
